import { createStore } from "vuex";
import proctoring from "./useProctoringStore";
import axios from "axios";
import createPersistedState from "vuex-persistedstate";

export default createStore({
  modules: {
    proctoring,
  },

  state: {
    access: null,
    refresh: null,
    user: null,
    roles: [],
    isAuthenticated: false,
    accessToken: null,
    refreshToken: null,
    tokenExp: null,
  },

  getters: {
    isAuthenticated: (state) => state.isAuthenticated,
    user: (state) => state.user,
    access: (state) => state.access,
    refresh: (state) => state.refresh,
    roles: (state) => state.roles,
    getAccessToken: (state) => state.accessToken,
    getRefreshToken: (state) => state.refreshToken,
    getTokenExp: (state) => state.tokenExp,
  },

  mutations: {
    setLoggedInInfo(state, payload) {
      const userData = payload.data;

      state.isAuthenticated = true;

      state.access = userData.access;
      state.refresh = userData.refresh;

      state.user = {
        id: userData.user_id,
        full_name: userData.full_name,
        email: userData.email,
        phone: userData.phone,
      };

      state.roles = userData.roles || [];
    },

    setLogout(state) {
      state.access = null;
      state.refresh = null;
      state.user = null;
      state.roles = [];
      state.isAuthenticated = false;
      state.accessToken = null;
      state.refreshToken = null;

      localStorage.removeItem("exam_id");
      localStorage.removeItem("exam_name");
      localStorage.removeItem("room_id");
      localStorage.removeItem("room_name");
      localStorage.removeItem("exam_attempt_id");
    },
    setAccessToken(state, token) {
      state.accessToken = token;
    },
    setRefreshToken(state, token) {
      state.refreshToken = token;
    },
    setExpDate(state, date) {
      state.tokenExp = date;
    },
  },

  actions: {
    async loginWithPassword({ commit, dispatch }, data) {
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_ROOT}/auth/login/`,
          data
        );

        commit("setLoggedInInfo", response.data);
        commit("setAccessToken", response.data.data.access);
        commit("setRefreshToken", response.data.data.refresh);

        dispatch("saveToken");

        return response.data;
      } catch (error) {
        console.error("Login Error:", error);
        return null;
      }
    },

    logout({ commit }) {
      commit("setLogout");
      commit("setExpDate", null);
    },
    saveToken({ state, commit }) {
      const token = state.accessToken;
      if (!token) return;

      try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split("")
            .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
            .join("")
        );
        const decoded = JSON.parse(jsonPayload);

        const expDate = new Date(decoded.exp * 1000);
        commit("setExpDate", expDate);
      } catch (err) {
        console.error("Failed to decode JWT:", err);
      }
    },
  },

  plugins: [
    createPersistedState({
      key: "exam-app",
      storage: window.localStorage,
      paths: [
        "access",
        "refresh",
        "user",
        "roles",
        "isAuthenticated",
        "accessToken",
        "refreshToken",
        "tokenExp",
      ],
    }),
  ],
});
